import { useState, useEffect, createContext, useContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import RoomsPage from "@/pages/RoomsPage";
import BookingPage from "@/pages/BookingPage";
import PaymentPage from "@/pages/PaymentPage";
import DiningPage from "@/pages/DiningPage";
import RestaurantPage from "@/pages/RestaurantPage";
import ContactPage from "@/pages/ContactPage";
import PolicyPages from "@/pages/PolicyPages";
import AdminPage from "@/pages/AdminPage";
import { Toaster } from "@/components/ui/sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const ContentContext = createContext({});
export const useContent = () => useContext(ContentContext);

function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [rooms, setRooms] = useState([]);
  const [menu, setMenu] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const [contentRes, roomsRes, menuRes] = await Promise.all([
        axios.get(`${API}/content`),
        axios.get(`${API}/rooms`),
        axios.get(`${API}/menu`)
      ]);
      setContent(contentRes.data);
      setRooms(roomsRes.data);
      setMenu(menuRes.data);
    } catch (e) {
      console.error("Failed to fetch content:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <ContentContext.Provider value={{ content, rooms, menu, loading, refetch: fetchData }}>
      {children}
    </ContentContext.Provider>
  );
}

function ScrollToTop() {
  const { pathname } = require("react-router-dom").useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ContentProvider>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/rooms" element={<RoomsPage />} />
              <Route path="/booking" element={<BookingPage />} />
              <Route path="/payment" element={<PaymentPage />} />
              <Route path="/dining" element={<DiningPage />} />
              <Route path="/restaurant" element={<RestaurantPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/privacy-policy" element={<PolicyPages page="privacy" />} />
              <Route path="/refund-policy" element={<PolicyPages page="refund" />} />
              <Route path="/terms" element={<PolicyPages page="terms" />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster />
      </ContentProvider>
    </BrowserRouter>
  );
}

export default App;
